let View = require('views/view')
let app = require('application')

module.exports = View.extend({
  template: require('views/templates/events/events'),
  events () { // On récupère ici les events de view (les event globaux) pis on ajoute les spécifiques a cette vue (SOURCE : http://stackoverflow.com/questions/9403675/backbone-view-inherit-and-extend-events-from-parent)
    return _.extend({}, View.prototype.events, {
      'click #nav-division-tab': 'listDivision',

      'click #btn-show-form-event': 'showFormEvent',
      'click .events-hide-form': 'hideFormEvent',
      'click .edit-event': 'update',
      'click .delete-event': 'delete',

      'click #btn-show-form-division': 'showFormDivisionEvent',
      'click .division-hide-form': 'hideFormDivisionEvent',
      'click .edit-division': 'updateDivision',
      'click .delete-division': 'deleteDivision',

      'click .filter': 'list'
    })
  },
  list () {
    let data = $('#form-pagination').serialize()
    this.hideFormEvent()

    $('#events-list').html('<i class="fa fa-refresh fa-spin"></i> Chargement en cours...')

    app.ajax({
      url: '/events',
      data,
      success: (...args) => this.refreshList(...args)
    })
  },
  refreshList (events, status, xhr) {
    $('#events-list').html(require('views/templates/events/list')({
      events,
      searchTerms: xhr.getResponseHeader('ps-search-term'),
      total: xhr.getResponseHeader('ps-total-row')
    })).show()

    app.pagination('events', xhr)
    app.initList()
  },
  update (e) {
    if (e) e.preventDefault()
    let id = $(e.currentTarget).closest('tr').data('id')
    if (id) {
      app.ajax({
        url: '/events',
        data: { id },
        complete: app.onComplete({
          success: (res) => this.showFormEvent(res)
        })
      })
    }
  },
  showFormEvent (data) {
    $('#events-form-ctn').empty().html(require('views/templates/events/form')(data)).show()
    $('#btn-show-form-event').attr('disabled', true)
    this.prepareFormEvent()
  },
  hideFormEvent (e) {
    $('#events-form-ctn').hide().empty()
    $('#btn-show-form-event').attr('disabled', false)
  },
  prepareFormEvent (e) {
    var d = new Date()

    app.initDateTimepickers('input[name=date].datepicker', { minDate: d })

    app.ajax({
      url: '/division',
      complete: app.onComplete({
        success: (d) => {
          let data = d.map(({division, sport, pays, id_division}) => ({ id: id_division, text: `${sport} - ${division} (${pays})` }))
          app.select2('#id_division-ui', { data })
        }
      })
    })

    app.validator('events-form', [
      { name: 'evenement', display: 'Nom de l\'évènement', rules: 'required' },
      { name: 'date', display: 'Date de l\'évènement', rules: 'required' },
      { name: 'id_division', display: 'Division de l\'évènement', rules: 'required' }
    ], this.processFormEvent.bind(this))
  },
  processFormEvent (e) {
    let type = 'POST'
    if ($('#id-evenement').val()) {
      type = 'PUT'
    }

    let data = $('#events-form').serialize()
    app.ajax({
      url: '/events',
      type,
      data,
      complete: app.onComplete({
        success: (r) => this.list(r)
      })
    })
  },
  delete (e) {
    if (e) e.preventDefault()
    let id = $(e.currentTarget).closest('tr').data('id')
    bootbox.confirm({
      message: 'Êtes vous sûr ?',
      buttons: {
        confirm: {
          label: 'Oui',
          className: 'btn-success'
        },
        cancel: {
          label: 'Non',
          className: 'btn-danger'
        }
      },
      callback: (result) => {
        if (result) {
          app.ajax({
            url: '/events',
            type: 'DELETE',
            data: { id },
            complete: app.onComplete({
              success: (r) => {
                $('.row-event[data-id=' + id + ']').fadeOut('slow')
              }
            })
          })
        }
      }
    })
  }
})
